
import {
  IconButton,
  InputAdornment,
  TextFieldProps
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, TextInput } from "../../components";

export function PasswordInput({ sx, ...rest }: TextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <TextInput
      type={ showPassword ? "text" : "password" }
      InputProps={ {
        endAdornment: (
          <InputAdornment position="end" aria-hidden={ true }>
            <IconButton
              sx={ {
                "&.Mui-focusVisible": {
                  outline: `2px solid ${theme.palette.text?.primary}`,
                  outlineOffset: "2px",
                  borderRadius: "2px"
                }
              } }
              aria-label={ t("toggle_visibility", { name: rest.label }) }
              aria-pressed={ showPassword }
              onMouseDown={ () => setShowPassword(true) }
              onMouseUp={ () => setShowPassword(false) }
              onTouchStart={ () => setShowPassword(true) }
              onTouchEnd={ () => setShowPassword(false) }
              onKeyDown={ (e) => {
                if (e.key === " " || e.key === "Enter") {
                  e.preventDefault();
                  setShowPassword(true);
                }
              } }
              onKeyUp={ (e) => {
                if (e.key === " " || e.key === "Enter") {
                  setShowPassword(false);
                }
              } }
            >
              {
                showPassword
                  ? <Icon icon={ "Icons_visible" } color={ theme.customColors.systemPrimary02 } size={ 24 }/>
                  :<Icon icon={ "Icons_not-visible" } color={ theme.customColors.systemPrimary02 } size={ 24 }/>
              }
            </IconButton>
          </InputAdornment>
        )
      } }
      sx={ {
        ...sx,
        "input[type=\"password\"]::-ms-reveal": { display: "none" },
        "input[type=\"password\"]::-webkit-credentials-auto-fill-button": {
          opacity: 0,
          pointerEvents: "none",
          position: "absolute"
        }
      } }
      { ...rest }
    />
  );
}
